module.exports = __webpack_public_path__ + "img/login.b711a615.png";